import React, { useState } from 'react';

import './index.scss';
import LocaleAsString from '../../LocaleEngine/LocaleAsString';

/*
Params: text(string), limit (integer), mode ([char, word]), sufix (string)
*/
export default function TextTruncater(props) {
    const [isTruncated, setIsTruncated] = useState(props.defaultExpanded ? false : true);

    function createMarkup(text) {
        return { __html: text };
    }

    function getMoreTextDiv() {
        let truncateSufix = props.sufix;
        if (truncateSufix === '' || typeof truncateSufix === 'undefined') truncateSufix = '...';

        let truncateLimit = props.limit;
        if (truncateLimit <= 0 || typeof truncateLimit === 'undefined') truncateLimit = 300;

        let truncateMode = props.mode;
        if (truncateMode === '' || typeof truncateMode === 'undefined') truncateMode = 'char';
        if (truncateMode !== 'word' && truncateMode !== 'char') truncateMode = 'char';

        if (!isTruncated) {
            return <div><span dangerouslySetInnerHTML={createMarkup(props.text)}></span><span className="toggler" onClick={() => setIsTruncated(!isTruncated)}> show less</span></div>;
        }
        if ((props.text).length <= truncateLimit){
            return <span dangerouslySetInnerHTML={createMarkup(props.text)} />
        }

        // truncate's limit correction, truncating by word
        if (truncateMode === 'word') {
            for (let i = truncateLimit; i < (props.text).length; i--) {
                if (props.text[i] === " ") {
                    truncateLimit = i;
                    break;
                }
            }
        }

        let finalText = props.text.substr(0, truncateLimit);
        finalText += truncateSufix;

        return (
            (props.showMore ?
                <div className="textTruncated showMore">
                    {finalText}
                    <span onClick={props.Function ? () =>  props.Function(true) : () => setIsTruncated(!isTruncated)}>{LocaleAsString("lo.listings.item.more_details")}</span>
                </div>
                :
                <div>
                    <span className="textTruncated" dangerouslySetInnerHTML={createMarkup(finalText)} />
                    <span className="toggler" onClick={props.Function ? () =>  props.Function(true) : () => setIsTruncated(!isTruncated)}>{LocaleAsString("lo.listings.item.more_details")}</span>
                </div>
            )
        );
    }

    if (!props.text) {
        return <React.Fragment />;
    }

    return (
        <React.Fragment>
            {getMoreTextDiv()}
        </React.Fragment>
    )
}
